<template>
    <tr class="c-tr" @click="viewSupporter(data.email)">
        <td>{{ data.full_name }}</td>
        <td>{{ data.email }}</td>
        <td>{{ data.phone }}</td>
        <td align="right">{{ formatNumber(data.num_of_donations) }}</td>
        <td align="right">{{ formatCurrency(data.amount) }}</td>
        <td align="right">{{ formatCurrency(data.payout_amount) }}</td>
    </tr>
</template>

<script>
export default {
    name: 'TableItem',
    props: {
        data: Object,
    },
    methods: {
        viewSupporter(email) {
            this.$router.push({ name: 'SupporterView', params: { email } });
        },
        formatNumber(number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        formatDate(date) {
            return this.$moment(date).format('MM/DD/YYYY HH:mm');
        },
        formatCurrency(amount) {
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
        },
    },
};
</script>

<style lang="scss" scoped>
.c-tr {
    td {
        color: #7c7c7a;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        cursor: pointer;

        &:first-child {
            min-width: 200px;
        }
    }
}
</style>
